import { render } from "./ScrollytellingPage.vue?vue&type=template&id=5becbe22&scoped=true"
import script from "./ScrollytellingPage.vue?vue&type=script&lang=js"
export * from "./ScrollytellingPage.vue?vue&type=script&lang=js"

import "./ScrollytellingPage.vue?vue&type=style&index=0&id=5becbe22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5becbe22"]])

export default __exports__